import { gsap } from "gsap";
/* The following plugin is a Club GSAP perk */
import { SplitText } from 'gsap/SplitText';
gsap.registerPlugin(SplitText);

export default function() {
  const headings = document.querySelectorAll(".js-heading-underline");
  // console.log(headings);

  headings.forEach((text) => {
    const underline = text.querySelector('u');

    const split = new SplitText(text, {
      type: 'words',
      wordsClass: 'anim-text-line',
    });
    const words = split.words;

    // Create a ScrollTrigger for each heading
    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: text, 
        start: "top 80%", 
        toggleActions: "play none none none", 
      }
    });

    // Animate each word into place from 100px above, fading in:
    tl.set(text, {opacity: 1});
    tl.fromTo(words, {
      yPercent: 100,
      opacity: 0,
    }, {
      duration: 0.5, 
      yPercent: 0,
      stagger: 0.2,
      opacity: 1,
      ease: "power2.out",
    });
    // Check if there's an underline element before animating it
    if (underline) {
      tl.from(underline, {
        backgroundPositionX: `-${underline.offsetWidth}px`,
        ease: "power2.in",
        duration: 0.2
      });
    }
  });
}